<template>
  <nav aria-label="breadcrumb">
    <div class="breadcrumb">
      <span v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item" :class="{ active: index === breadcrumbs.length - 1 }">
        <a v-if="index !== breadcrumbs.length - 1" :href="crumb.to">{{ crumb.text }}</a>
        <span v-else>{{ crumb.text }}</span>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;

.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px auto;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  list-style: none;
  max-width: 1200px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  color: #333 !important;
  font-size: 14px;
  font-weight: 400;
  
  &:not(:last-child) {
    margin-right: 4px;
  }
  
  a {
    color: #666 !important;
    text-decoration: none;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;
    
    &:hover {
      color: #00D4AA !important;
      background: rgba(0, 212, 170, 0.1);
    }
  }
  
  &.active {
    color: #00D4AA !important;
    font-weight: 500;
  }
  
  &::before {
    content: ">";
    padding: 0 6px;
    color: #999;
    font-size: 12px;
  }
  
  &:first-child::before {
    display: none;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .breadcrumb {
    margin: 15px 10px;
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .breadcrumb-item {
    font-size: 13px;
    
    a {
      padding: 3px 6px;
    }
    
    &::before {
      padding: 0 4px;
    }
  }
}
</style>